import { Link, useParams } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { LEGAL } from "../lib/legal";

export const LEGAL_TABS = [["terms", "Terms of Service"], ["privacy", "Privacy Policy"], ["data", "Data Collection"]];

export const LegalBody = ({ doc }) => (
  <article data-testid={`legal-${doc}`} className="space-y-6">
    <p className="font-mono text-[11px] uppercase tracking-widest text-neutral-500">Effective {LEGAL.effective} · version {LEGAL.version}</p>
    {LEGAL[doc].map(([h, body]) => (
      <section key={h}>
        <h2 className="font-display text-lg font-semibold text-red-500">{h}</h2>
        {body.map((p, i) => <p key={i} className="mt-2 text-sm leading-relaxed text-neutral-300">{p}</p>)}
      </section>
    ))}
  </article>
);

export const LegalTabs = ({ active, onPick }) => (
  <div role="tablist" className="flex flex-wrap gap-1 border-b border-[#1f1f1f]">
    {LEGAL_TABS.map(([k, l]) => {
      const cls = `relative px-3 py-3 font-mono text-[11px] uppercase tracking-widest transition-colors ${active === k ? "text-white" : "text-neutral-500 hover:text-neutral-200"}`;
      const inner = <>{l}{active === k && <span className="absolute inset-x-2 bottom-0 h-0.5 bg-red-600" />}</>;
      return onPick
        ? <button key={k} role="tab" type="button" data-testid={`legal-tab-${k}`} onClick={() => onPick(k)} className={cls}>{inner}</button>
        : <Link key={k} role="tab" to={`/legal/${k}`} data-testid={`legal-tab-${k}`} className={cls}>{inner}</Link>;
    })}
  </div>
);

export default function Legal() {
  const { doc = "terms" } = useParams();
  const active = LEGAL[doc] ? doc : "terms";
  return (
    <div className="relative">
      <Navbar />
      <main className="relative z-10 mx-auto max-w-3xl px-5 pb-24 pt-12 sm:px-8">
        <p className="rea-label text-red-500">// legal & disclosures</p>
        <h1 className="font-hero mt-3 text-3xl sm:text-4xl">{LEGAL_TABS.find((t) => t[0] === active)[1]}</h1>
        <div className="mt-8"><LegalTabs active={active} /></div>
        <div className="mt-8"><LegalBody doc={active} /></div>
      </main>
    </div>
  );
}
